import { produce } from 'immer'
import type { State, Action } from './typings'

export const bulkActionReducer = produce((draft: State, action: Action) => {
  switch (action.type) {
    case 'setActive':
      draft.activeBulkAction = action.payload
      draft.errors = new Map()
      draft.isValidating = false
      break
    case 'setErrors':
      draft.errors = action.payload ?? new Map()
      draft.isValidating = false
      break
    case 'startValidating':
      draft.isValidating = true
      break
  }
})
